import React from 'react';
import {connect} from 'react-redux';
import {useHistory} from 'react-router-dom';
import './EditAdmin.scss';
import Ebutton from '../../../common/components/Ebutton/Ebutton';
import PropTypes from 'prop-types';
import {useFormik} from 'formik';
import actions from '../../../redux/actions';
import * as yup from 'yup';
import _ from 'lodash';

/**
 * @description
 * @param { object } props no redux
 * @return { * } component
 */
const InputErrorMessage = ({formik, name, className = ''}) => {
    return (
        <div className={'form-error ' + className} >
            { _.get( formik.touched, name ) && _.get( formik.errors, name ) }
        </div>
    );
};

const EditAdmin = (props) => {
    const {
        name,
        adminSelected,
        putAdmin,
        currentUser,
        showSidebar,
    } = props;
    const validationSchema = yup.object({
        email: yup
            .string('Ingrese email')
            .email('email invalido')
            .required('Ingrese email'),
    });

    const history = useHistory();

    const formik = useFormik({
        initialValues: {
            id: adminSelected?.id ? adminSelected?.id : '',
            email: adminSelected?.email || '',
            firstName: adminSelected?.firstName || '',
            lastName: adminSelected?.lastName || '',
            // password: '',
        },
        validationSchema: validationSchema,
        onSubmit: (values) => {
            const body = {
                id: values.id,
                user: _.omit( values, ['id'] ),
            };
            putAdmin(body);
            history.goBack();
        },
    });

    return (
        <div className={showSidebar && window.innerWidth <= 700 ? 'ul-div-background bg-mt-10' : 'ul-div-background'}>
            <p className="ul-p-name">{name}</p>
            <div className="ul-div-section">
                <div className="ul-div-sect-header">
                    <div>
                        <p className="ul-p-title">{currentUser ? 'MIS DATOS' : 'EDITAR ADMINISTRADOR'}</p>
                        <hr id="id-hr"/>
                    </div>
                </div>

                <div className="ul-div-form">
                    {currentUser &&
                        (
                            <div className="eu-radio-container change-pass"
                                onClick={ ()=>history.push('change_password') }
                            >Cambiar contraseña
                            </div>
                        )
                    }

                    <form className="eu-form" onSubmit={formik.handleSubmit}>
                        <div className="eu-div-container">
                            <div className="eu-div-input">
                                <text className="eu-text-l eu-f-label">Nombre</text>
                                <text className="eu-text-s eu-f-label">Apellido</text>
                            </div>
                            <div className="eu-div-input">
                                <input
                                    className="eu-input-l" name="firstName" value={formik.values.firstName}
                                    onChange={formik.handleChange}
                                />
                                <input
                                    className="eu-input-s" name="lastName" value={formik.values.lastName}
                                    onChange={formik.handleChange}
                                />
                            </div>
                            <div className="eu-div-input">
                                <text className="eu-text-l eu-f-label">Email</text>
                            </div>
                            <div className="eu-div-input">
                                <input
                                    disabled={true}
                                    className="eu-input-l" name="email" value={formik.values.email}
                                    onChange={formik.handleChange}
                                />
                            </div>
                            <div className="eu-div-input">
                                <InputErrorMessage formik={formik} name='email' className='eu-input-l' />
                            </div>
                            <Ebutton classNameButton="eu-btn" type="submit" text="GUARDAR CAMBIOS"/>
                        </div>

                    </form>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
    name: localStorage.getItem('name'),
    users: state.home.users,
    columnData: state.home.columnData,
    title: state.home.title,
    adminSelected: state.home.adminSelected,
    showSidebar: state.common.showSidebar,
});

const mapDispatchToProps = (dispatch) => ({
    switchOfUser: (name) => dispatch(actions.home.switchOfUser(name)),
    putAdmin: (admin) => dispatch(actions.home.putAdminRequest(admin)),
});

EditAdmin.propTypes = {
    name: PropTypes.string,
    title: PropTypes.string,
};


export default connect(mapStateToProps, mapDispatchToProps)(EditAdmin);

